import { useQuery } from "@tanstack/react-query";
import { summaryApi } from "@/api/summary";

export function useSummary() {
  return useQuery({
    queryKey: ["summary"],
    queryFn: () => summaryApi.get(),
    refetchInterval: 30_000,
  });
}
